import styles from './Rewards.module.css';
import {
  useGetIwocapayReferral,
  useGetIwocapayReferrals,
} from '../../api/lending/lapiHooks';
import { CopyButton } from '../../components/CopyButton/CopyButton';
import countingHotAirBalloonSrc from '../../components/svg/CountingHotAirBalloon.svg';
import { copy } from '../../components/util/copy';

const REFERRAL_URL = 'iwoca.co.uk/iwocapay-sellers/?referral_code=';

export const Rewards = () => {
  return (
    <div className={styles.Rewards}>
      <div className={styles.contentContainer}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Know anyone who needs to get paid? Pass it on and share £200
          </h1>
          <p className={styles.description}>
            Refer a business to iwocaPay and once they’re set up to offer
            iwocaPay you’ll both get a £100 voucher of your choice each. We’ll
            include your business name in your referral link, so your referrals
            know who to thank. By sending the referral you are letting us know
            you are happy with that.
          </p>
          <ReferralShareBox />
        </div>
      </div>
      <ReferralCount />
    </div>
  );
};

const ReferralShareBox = () => {
  const { iwocapayReferral } = useGetIwocapayReferral();

  const referralCode = iwocapayReferral?.referral_code || '';
  const referralCodeURL = REFERRAL_URL + referralCode;

  return (
    <>
      <p className={styles.getStarted}>
        Share your referral link and get them started
      </p>
      <div className={styles.referralBox}>
        <h2 className={styles.referralTitle}>Send invites to start earning</h2>
        <div className={styles.referralContainer}>
          <div className={styles.referralCode}>{referralCodeURL}</div>
          <CopyButton
            onClick={() => copy(referralCodeURL)}
            className={styles.referralCopyButton}
          >
            Copy referral link
          </CopyButton>
        </div>
      </div>
    </>
  );
};

const ReferralCount = () => {
  const { iwocapayReferrals } = useGetIwocapayReferrals();

  const referralCount = iwocapayReferrals?.referral_count || 0;

  return (
    <div className={styles.hotAirBalloonContainer}>
      <div className={styles.hotAirBalloonWrapper}>
        <div
          className={styles.hotAirBalloonCount}
          data-testid="number-of-referrals"
        >
          {referralCount}
        </div>
        <img
          src={countingHotAirBalloonSrc}
          alt="hotair balloon"
          className={styles.hotAirBalloon}
        />
      </div>
    </div>
  );
};
